import { Grid } from '@mui/material';
import React, { useState, useEffect } from 'react';
import BillsCard from './BillsCard';
import TotalBillsCard from './TotalBillsCard';
import Greencardicon from '../../assests/Greencardicon.svg';
import Bluecardicon from '../../assests/Bluecardicon.svg';
import { useQuery } from '@apollo/client';
import {
  GET_METADATA,
  FETCH_DUE_BILLS,
} from '../../services/BillsQueries/BillsService';
import { useSnackbar } from 'notistack';
import { BILLS } from '../../shared/Strings';

const BillsSummary = () => {
  const [totalDue, setTotalDue] = useState(0);
  const [totalExpenditure, setTotalExpenditure] = useState(0);
  const [dueBills, setDueBills] = useState();
  const [statusDue,setStatusDue]=useState();
  const [billCount, setBillCount] = useState({
    dueBillCount: '',
    expenditureBillCount: ''
  })
  const { enqueueSnackbar } = useSnackbar();
  const billsData = {
    title: BILLS.title,
    amount: `$${totalDue}`,
    orangeLabel: `${statusDue} ${dueBills}`,
    primaryBtnTitle: BILLS.PAY_BILL,
    secondaryBtnTitle: BILLS.VIEW_DETAILS,
  };

  const cardbillData = [
    {
      title: BILLS.TOTAL_BILL_DUE,
      amount: `$${totalDue}`,
      billstext: BILLS.NO_OF_BILLS,
      billsCount: billCount.dueBillCount,
      icon: Bluecardicon,
      background: 'rgba(3, 111, 203, 0.1)',
    },
    {
      title: BILLS.EXPENDITURE,
      amount: `$${totalExpenditure}`,
      billstext: BILLS.NO_OF_BILLS,
      billsCount: billCount.expenditureBillCount,
      icon: Greencardicon,
      background: 'rgba(20, 142, 60, 0.1)',
    },
  ];
  const billsMetadata = useQuery(GET_METADATA, {
    variables: {sourceUrl: ''},
  }, {
    onError: err => {
      enqueueSnackbar(BILLS.ON_ERROR_TEXT.WENT_WRONG_SUMMARY_TEXT, {
        variant: 'error',
      });
    },
  });

  const dueDayBills = useQuery(FETCH_DUE_BILLS, {
    variables: { dueDays: 30 },
  });

  useEffect(()=>{
    if(dueDayBills.error){
      enqueueSnackbar(BILLS.ON_ERROR_TEXT.WENT_WRONG_DUE_BILLS,{
        variant:'error'
      })
    }
  })

  useEffect(() => {
    if (billsMetadata.data) {
      const totalDue = billsMetadata.data?.billSummary?.totalDue;
      const totalExpenditure = billsMetadata.data?.billSummary?.totalSpent;
      setBillCount({
        dueBillCount: billsMetadata.data.billSummary.totalDueBills,
        expenditureBillCount: billsMetadata.data.billSummary.totalExpenditureBills,
      })
      setTotalDue(totalDue);
      setTotalExpenditure(totalExpenditure);
    }
  }, [billsMetadata.data]);

  useEffect(() => {
    if (dueDayBills.data) {
      const dueBills = dueDayBills.data?.fetchBillByDueDay?.totalDueDays;
      const statusDue= dueDayBills.data?.fetchBillByDueDay?.status;
      setDueBills(dueBills);
      setStatusDue(statusDue)
    }
  }, [dueDayBills.data]);

  return (
    <Grid container spacing={2} sx={{ mt: 1 }}>
      {cardbillData?.map((carddata, index) => (
        <Grid item key={index}>
          <TotalBillsCard cardbillData={carddata} />
        </Grid>
      ))}
      <Grid item>
        <BillsCard billsData={billsData} />
      </Grid>
    </Grid>
  );
};

export default BillsSummary;
